import { Stack } from "@mui/material";
import { FC, useEffect, useState } from "react";
import {
  Control,
  FieldErrors,
  FieldValues,
  UseFormGetValues,
  UseFormSetError,
  UseFormSetValue,
  UseFormWatch,
} from "react-hook-form";
import { Credential } from "../../graphql/types";
import { FormController } from "./FormController";
import { PrivateKeyInput } from "./PrivateKeyInput";

interface ISftpThings {
  control?: Control;
  errors?: FieldErrors;
  mode?: string;
  setError?: UseFormSetError<FieldValues>;
  setValue?: UseFormSetValue<FieldValues>;
  credential?: Credential;
  watch?: UseFormWatch<FieldValues>;
  getValues?: UseFormGetValues<FieldValues>;
  editingField?: string;
  setEditingField?: (e: string) => void;
  loading?: boolean;
}

const SftpThings: FC<ISftpThings> = ({
  control,
  errors,
  mode,
  watch,
  credential,
  setValue,
  getValues,
  setError,
  editingField,
  setEditingField,
  loading,
}) => {
  const [authType, setAuthType] = useState(credential?.properties.auth_type || "privateKey");

  useEffect(() => {
    if (!credential?.properties.auth_type && setValue) {
      setValue("auth_type", "privateKey");
    }
  }, [credential?.properties.auth_type, setValue]);

  const controllerAdditionalProps = {
    control: control,
    errors: errors,
    mode: mode,
    setError: setError,
    setValue: setValue,
    credential: credential,
    watch: watch,
    getValues: getValues,
    editingField: editingField,
    setEditingField: setEditingField,
    loading: loading,
  };

  return (
    <>
      <FormController
        elementType="textField"
        type="text"
        fieldName="username"
        label="Username"
        rules={{ required: true }}
        {...controllerAdditionalProps}
      />
      <Stack
        sx={{
          gridRow: "span 3",
        }}
      >
        <PrivateKeyInput
          authType={authType}
          control={control}
          errors={errors}
          mode={mode}
          credential={credential}
          setAuthType={setAuthType}
          passwordFieldname="password"
          privateKeyFieldname="pem_value"
          authTypeFieldname="auth_type"
          useSha1Fieldname="use_sha1"
          passphraseFieldname="passphrase"
        />
      </Stack>
      <FormController
        elementType="textField"
        type="text"
        fieldName="host"
        label="Host"
        rules={{ required: true }}
        {...controllerAdditionalProps}
      />
      <Stack sx={{ gridTemplateColumns: "1fr 1fr", gap: "16px 48px", marginBottom: "40px" }}>
        <FormController
          elementType="textField"
          type="text"
          fieldName="port"
          label="Port"
          rules={{ required: false }}
          {...controllerAdditionalProps}
        />
      </Stack>
    </>
  );
};

export { SftpThings };
